import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import AudienceContent from './AudienceContent'
export default class Audience extends Component {

   

    render() {
        let page = this.props.match.params.page;


        return (
            <div class="wrapper">

                <Navbar />
                <Mainmenu />
                <AudienceContent page={page} />
                <Footer />

            </div>


        )
    }
}
